import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Col, Container, FloatingLabel, Form, Image, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import RegistOrLogin from './RegistOrLogin';
import { LoginInfo } from '../App';
import { t } from 'i18next';
import * as RIcon from "react-icons/fa"
import MuiButton from "@mui/material/Button";

const Comment = (props) => {
    async function getStamp(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/stamp/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const location = useLocation()
	const [terms,setTerms] = useState("")
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const [stampOfficial,setStampOfficial] = useState(true)
    const [stampList,setStampList] = useState([])
    const [stampMessage,setStampMessage] = useState("")
    const [stampPage,setStampPage] = useState(0)
    const keyEvent = props.keyEvent

	useEffect(() => {

	},[location.pathname])

    useEffect(() => {
        if(stampPage > 0)
        getStamp(stampOfficial ? "bb37f7e5-7ea5-465a-8ae3-e6ac4bdd2341" : loginInfo.userId,stampPage).then(r => {
            if(r.result){
                setStampList(r.data)
                if(r.data.length === 0){
                    setStampMessage(<span>まだスタンプがありません。オリジナルのスタンプを登録してみませんか？：<Link to={"/stampManage"}>スタンプ管理</Link></span>)
                } else {
                    setStampMessage("")
                }
            }
        })
    },[stampPage,stampOfficial])

    return(
        <div id={"reply-"+props.id} style={{display:"none"}}>
        <FloatingLabel
        onClick={() => {
            if(loginInfo.result === false){
                props.dialog(t("common.loginToContinue"),<RegistOrLogin dialog={props.dialog} />)
            }
        }}
        onFocus={() => {if(keyEvent !== undefined) document.onkeydown = () => {}}}
        onBlur={() => {if(keyEvent !== undefined) document.onkeydown = keyEvent}}
        controlId={"reply-"+props.id+"-text"} label="コメントを記載" className='mb-3 w-100' style={{lineHeight:"20px"}} onInput={(e) =>{
            let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
            let n = e.nativeEvent.target.value.match(/\n/g)
            if(n === null){
                n = 1
            } else {
                n = n.length + 1
            }
            e.currentTarget.style.height = lineHeight * n + 30 + "px"
            document.querySelector(".textarea-"+props.id).style.height = lineHeight * n + 30 + "px"
        }}>
            <Form.Control
                className={"textarea-"+props.id}
                as="textarea"
                style={{ width:"inherits",height: '50px' }}
                required
            />
        </FloatingLabel>

        <MuiButton variant='outlined' onClick={() => {
            if(stampList.length > 0){
                setStampList([])
                setStampPage(0)
            } else {
                setStampPage(1)
            }
        }}>
        <RIcon.FaStamp style={{color:"#555555",cursor:"pointer",fontSize:"24px"}} /></MuiButton>&nbsp;
        <MuiButton variant='outlined' onClick={() => {
            let text = document.getElementById("reply-"+props.id+"-text")
            if(text.value.trim().length === 0){
                props.dialog("エラー","コメントを入力して下さい。")
                return
            }
            if(text.value.trim().length > 2500){
                props.dialog("エラー","コメントは2500文字以内にして下さい。")
                return
            }
            props.upload(props.postType,document.getElementById("reply-"+props.id+"-text").value,props.groupId,"",props.id)
            document.getElementById("reply-"+props.id).style.display = "none"
            document.getElementById("reply-"+props.id+"-text").value = ""
        }}>{t("common.comment")}</MuiButton>
        &nbsp;
        <MuiButton variant='outlined' onClick={() => document.getElementById("reply-"+props.id).style.display = "none"}>{t("common.cancel")}</MuiButton>
        {stampMessage}
        {stampList.length > 0 ? (
        <Container style={{border:stampList.length > 0 ? "1px solid #555555" : "none",borderRadius:"5px"}} className='mt-2'>
            <MuiButton onClick={() => {
                setStampOfficial(true)
                setStampPage(1)
            }} variant={stampOfficial ? 'contained' : "outlined"} className='m-3'>公式</MuiButton>
            <MuiButton onClick={() => {
                setStampOfficial(false)
                setStampPage(1)
            }} variant={!stampOfficial ? 'contained' : "outlined"} className='m-3'>保有</MuiButton>
        
            <Row>
                <Col style={{display:stampList.length > 0 ? "block" : "none",margin:"0 auto"}} className="m-1">
                    <Link to="/stampManage"><Icon.Plus style={{borderRadius:"5px",border:"3px solid #AAAAAA",fontSize:"64px",cursor:"pointer",width:"100px",height:"100px",margin:"0 auto"}} /></Link>
                </Col>
                {stampList.map((data,i) => {
                    if(i === 30){
                        return ""
                    }
                return <Col style={{margin:"0 auto"}} className="m-1" key={i}>
                            <Container style={{position:"relative",width:"100px",height:"100px"}} className="p-0">
                                {
                                // <Badge bg="white" style={{cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",right:"50px"}} onClick={() => navigate("/edit/"+data.group_id)}>
                                //     <Icon.PencilSquare style={{color:"#000000"}} /> <span style={{color:"#555555"}}>編集</span>
                                // </Badge>
                                // <FavoriteIcon type="image" id={data.group_id} style={{cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} favorite={data.favorite} dialog={dialog} />
                                }
                                <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="stamp" 
                                    onClick={() => {
                                        props.upload(props.postType,document.getElementById("reply-"+props.id+"-text").value,props.groupId,data.stamp_id,props.id)
                                        setStampList([])
                                        setStampPage(0)
                                        let text = document.getElementById("reply-"+props.id)
                                        text.style.display = "none"
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+ApiFetch.API_THUMB_EXT
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT
                                    }}
                                />
                            </Container>
                            <Container style={{fontWeight:"bold",fontSize:"15px"}}><Link to={"/image/"+(data.stamp_id)} style={{color:"#555555",textDecoration:"none"}}>{data.title}</Link></Container>
                        </Col>
                })}
            </Row>
        </Container>
        ) : ""}
        {stampList.length > 0 ? (
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {stampPage > 1 ? (
                    <Button onClick={() => {
                        let p = stampPage - 1
                        setStampPage(p)
                    } }>{t("common.prev")}</Button>
                ) : <Button disabled>{t("common.prev")}</Button>}
            {stampList.length > 30 ? (
                    <Button onClick={() => {
                        let p = stampPage + 1
                        setStampPage(p)
                    } }>{t("common.next")}</Button>
                ) : <Button disabled>{t("common.next")}</Button>}
        </Container>
        ) : ""}
        </div>
    )
}

export default Comment;
